const excelTableHeader = (list, t, listQuery, extension) => {
  const sheetName = 'Export';
  const fileNameSuffix = ' ' + new Date().toLocaleString() + `.${extension}`;
  const cleanList = list.map(({ __typename, ...rest }) => rest);

  switch (listQuery?.name ?? listQuery) {
    case 'pagedVerificationTypes': {
      return {
        formattedList: cleanList.map(z => ({
          [t('VerificationTypes.VerificationName')]: z.verificationName,
          [t('VerificationTypes.KindOfVerification')]: z.kindOfVerification,
          [t('VerificationTypes.IsActive')]: z.isActive
        })),
        fileName: [t('NavBar.VerificationTypes')] + fileNameSuffix,
        sheetName: sheetName
      };
    }
    default: {
      return { formattedList: cleanList, fileName: 'Export' + fileNameSuffix, sheetName: sheetName };
    }
  }
};
export default excelTableHeader;
